<app-login *ngIf="!(isLoggedIn$ | async)"></app-login>
<app-loader></app-loader>
<app-main-layout *ngIf="isLoggedIn$ | async"></app-main-layout>
